import React from 'react'
import Box from '@mui/material/Box';

const NoDataFound = props => {
    return (
        <div>
            <Box display="flex" mt={4} justifyContent="center">
                <h1>{props.message}</h1>
                <br/>
                 
            </Box>
        </div>
    )
}

export default NoDataFound